module.exports = __webpack_public_path__ + "img/skillsB-2.b46effa4.png";